var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" 版權所有 2020 LiveABC互動英語教學集團 | Hebron Soft Limited All Rights Reserved ")])
}
var staticRenderFns = []

export { render, staticRenderFns }